import {updateSessionId} from "./session";
import {deleteFile, getFile, putFile} from "../api/data";
import {getStatus} from "../api/schools";
import {dispatchError} from "../utils";

const initialState = {
  uploadErrors: null,
  filesUploaded: undefined,
  downloadedFile: null,
  getUploadedFileApiErrors: null,
  deleteUploadedFileApiErrors: null,
  deleteUploadedFileSucceeded: null,
  schoolsCanUploadList: null,
  schoolFiles: null,
  schoolStatusApiErrors: null
}

export const uploadFiles = (file, school) => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData,
    schoolid: school.id
  };

  const uploadBody = {
    file: file,
    bucket: school.atpCode,
    filename: file.name
  }

  try {

    const response = await putFile(queryParams, uploadBody);

    dispatch({
      type: 'uploads/filesUploaded'
    });
    dispatch(updateSessionId(response.loggedInUserSessionId));
  } catch (errors) {
    dispatch ({
      type: 'uploads/filesUploadFailed',
      errors: errors
    });
  }
}

export const getUploadedFile = (bucket, fileName) => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  const getFileBody = {
    bucket: bucket,
    filename: fileName
  }

  try {
    const response = await getFile(queryParams, getFileBody);
    dispatch ({
      type: 'uploads/getUploadedFileSucceeded',
      payload: response
    });
  } catch (errors) {
    dispatch ({
      type: 'uploads/getUploadedFileApiError',
      payload: errors
    })
  }
}

export const deleteUploadedFile = (bucket, fileName) => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  const getFileBody = {
    bucket: bucket,
    filename: fileName
  }

  try {
    const response = await deleteFile(queryParams, getFileBody);

    dispatch ({
      type: 'uploads/deleteUploadedFileSucceeded',
      payload: response
    });

    dispatch(updateSessionId(response.loggedInUserSessionId));
  } catch (errors) {
    dispatch ({
      type: 'uploads/deleteUploadedFileApiError'
    })
  }
}

export const getSchoolFiles = (school) => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData,
    atpCode: school.atpCode
  }

  try {
    const fileStatus = await getStatus(queryParams);
    const files = await [fileStatus];

    await dispatch(updateSessionId(fileStatus.loggedInUserSessionId));

    await dispatch({
      type: 'uploads/getSchoolFilesApiSuccess',
      payload: files
    });

  } catch (error) {
    await dispatchError(error, {
      type: 'uploads/getSchoolFilesApiFailure',
      payload: 'Api Error with Get School File Status'
    }, dispatch);
  }
}

export const setSchoolsCanUploadList = (schoolsCanUploadList) => {
  return {
    type: 'uploads/setSchoolsCanUploadList',
    payload: schoolsCanUploadList
  }
}

export const clearUploadErrors = () => {
  return {
    type: 'uploads/clearUploadErrors'
  }
}

export const clearFilesUploaded = () => {
  return {
    type: 'uploads/clearFilesUploaded'
  }
}

export const clearUploadedFile = () => {
  return {
    type: 'uploads/clearUploadedFile'
  }
}

export const clearDeleteUploadedFile = () => {
  return {
    type: 'uploads/clearDeleteUploadedFile'
  }
}

export default function uploadsReducer(state = initialState, action) {
  const {type, payload} = action;

  switch (type) {
    case 'uploads/filesUploaded':
      return {
        ...state,
        filesUploaded: true
      }
    case 'uploads/filesUploadFailed':
      return {
        ...state,
        filesUploaded: false,
        errors: payload
      }
    case 'uploads/getUploadedFileSucceeded':
      return {
        ...state,
        getUploadedFileApiErrors: null,
        downloadedFile: payload
      }
    case 'uploads/getUploadedFileApiError':
      return {
        ...state,
        downloadedFile: null,
        getUploadedFileApiErrors: payload
      }
    case 'uploads/clearUploadErrors':
      return {
        ...state,
        filesUploaded: null,
        uploadErrors: null
      }
    case 'uploads/clearUploadedFile':
      return {
        ...state,
        downloadedFile: null,
        getUploadedFileApiErrors: null
      }
    case 'uploads/deleteUploadedFileSucceeded':
      return {
        ...state,
        deleteUploadedFileSucceeded: true,
        deleteUploadedFileApiErrors: null
      }
    case 'uploads/deleteUploadedFileApiErrors':
      return {
        ...state,
        deleteUploadedFileSucceeded: null,
        deleteUploadedFileApiErrors: payload
      }
    case 'uploads/clearDeleteUploadedFile':
      return {
        ...state,
        deleteUploadedFileSucceeded: null,
        deleteUploadedFileApiErrors: null
      }
    case 'uploads/clearFilesUploaded':
      return {
        ...state,
        filesUploaded: null,
        uploadErrors: null
      }
    case 'uploads/setSchoolsCanUploadList':
      return {
        ...state,
        schoolsCanUploadList: payload
      }
    case 'uploads/getSchoolFilesApiSuccess':
      return {
        ...state,
        schoolFiles: payload,
        schoolStatusApiErrors: null
      }
    case 'uploads/getSchoolFilesApiFailure':
      return {
        ...state,
        schoolStatusApiErrors: payload,
        schoolFiles: null
      }
    default:
      return state;
  }
}
